import { CustomersIcon } from "@moznsystems/mozn-ui";
import type { FC, FunctionComponent, SVGProps } from "react";
import { TENANTS } from "./constants";
import { TENANTS_ROUTE } from "./routes";

export const GROUPS = {
	MAIN: "Main",
};

export type NavigationType = {
	group: string;
	label: string;
	url: string;
	routes?: string[];
	icon:
		| FunctionComponent<
				SVGProps<SVGSVGElement> & {
					version?: "1" | "2";
				}
		  >
		| FC<SVGProps<SVGSVGElement>>;
	subItems: SubNavigationType[];
};

type SubNavigationType = {
	label: string;
	url: string;
	routes: string[];
};

const navigation: NavigationType[] = [
	{
		group: GROUPS.MAIN,
		label: TENANTS,
		url: TENANTS_ROUTE,
		icon: CustomersIcon,
		subItems: [],
	},
];

export const getNavigationItems = () => {
	return navigation;
};
